import { render, staticRenderFns } from "./LoadingComponent.vue?vue&type=template&id=26356792&scoped=true&"
import script from "./LoadingComponent.vue?vue&type=script&lang=js&"
export * from "./LoadingComponent.vue?vue&type=script&lang=js&"
import style0 from "./LoadingComponent.vue?vue&type=style&index=0&id=26356792&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26356792",
  null
  
)

export default component.exports